<template>
  <div class="main-header">
    <div class="left">
      <div class="logo">
				<img class="logo-img" :src="logoImg">
        <span>宝达集团人资管理系统</span>
      </div>
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        text-color="#fff"
        active-text-color="#FFF"
        background-color="#57bafe"
        :default-active="$route.path"
        router
        @select="handleSelect"
      >
        <el-menu-item index="/Home">首页</el-menu-item>
        <el-sub-menu index="1" popper-class="header-popper">
          <template #title>基础信息设置</template>
          <el-menu-item index="/jobGrade">岗位级别设置</el-menu-item>
          <el-menu-item index="/mealGrade">饭补级别设置</el-menu-item>
            <el-menu-item index="/insureGrade">社保级别设置</el-menu-item>
            <el-menu-item index="/insureCompany">入保企业设置</el-menu-item>
            <el-menu-item index="/sysSetting">其他设置</el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/personalInfo">个人信息管理</el-menu-item>
        <el-menu-item index="/payroll">工资管理</el-menu-item>
        <el-sub-menu index="2" popper-class="header-popper">
          <template #title>工资报表</template>
          <el-menu-item index="/report-1">年度工资汇总表</el-menu-item>
          <el-menu-item index="/report-2">部门年度工资汇总表</el-menu-item>
          <el-menu-item index="/report-3">部门月度工资明细表</el-menu-item>
          <el-menu-item index="/report-4">工资统计</el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/dept_center">中心管理</el-menu-item>
        <el-menu-item index="/department">部门管理</el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <el-dropdown @command="handleCommand" v-if="user.name">
        <span class="el-dropdown-link">
          你好，{{ user.name }}！
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="3" v-if="powers.indexOf('sysuser') >= 0">用户管理</el-dropdown-item>
            <el-dropdown-item command="2">修改密码</el-dropdown-item>
            <el-dropdown-item command="1">退出</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <el-button v-if="!user.name" type="primary" @click="login" plain round
        >登录</el-button
      >
    </div>
  </div>
</template>

<script setup>
import { ArrowDown } from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

const user = ref({
  name: "",
});

const powers = ref("")

onMounted(() => {
  user.value.name = localStorage.getItem("name");
  powers.value = localStorage.getItem("powers");
});
//logo图片
const logoImg = require("@/assets/img/logo-bd.png");
// 导航
const handleSelect = (key, keyPath) => {
  console.log(key, keyPath);
};
//下拉菜单
const handleCommand = (command) => {
  if (command == 1) {
    localStorage.removeItem("name");
    localStorage.removeItem("token");
    localStorage.removeItem("powers");
    localStorage.clear();
    window.location.href = "/";
  } else if (command == 2) {
    router.push("/passwordChange");
  } else if (command == 3) {
    router.push("/user");
  }
  // console.log(command);
};

//goto login page
const login = () => {
  window.location.href = "/";
};
</script>

<style lang="scss" scoped>
//scss
</style>
